/*
  AP — TAKSİT TUTARINI BEDEN DEĞİŞİNCE GÜNCELLER.

  Sorun: müşteri beden seçtiğinde temanın kendi JS'i fiyatı yeniden yazıyor.
  Taksit tutarı Liquid'de basıldığı için olduğu yerde kalıyordu.

  Çözüm: Liquid her varyant için taksit tutarını HAZIR BİÇİMLENMİŞ olarak
  <script data-ap-taksit-fiyatlar> içine yazar; burası yalnızca o metni
  yerine koyar. Burada hiçbir para hesabı ya da biçimlendirmesi YOK —
  yanlış yuvarlama riski de yok. (kampanya.js ile aynı yöntem.)
*/
(function () {
  'use strict';

  var harita = {};
  var izleniyor = new WeakSet();
  var planlandi = false;

  function haritayiYukle() {
    var kaynaklar = document.querySelectorAll('[data-ap-taksit-fiyatlar]');
    for (var i = 0; i < kaynaklar.length; i++) {
      try {
        var veri = JSON.parse(kaynaklar[i].textContent);
        for (var vid in veri) {
          if (Object.prototype.hasOwnProperty.call(veri, vid)) harita[vid] = veri[vid];
        }
      } catch (e) {
        /* bozuk JSON: sessizce geç, Liquid'in bastığı ilk tutar yerinde kalır */
      }
    }
  }

  /*
    Rozet hangi varyanta ait? Rozet sepet formunun İÇİNDE değil (başlık bloğu
    ile satın alma bloğu kardeş). Bu yüzden yukarı doğru çıkıp, içinde sepet
    formu olan EN YAKIN kabı buluyoruz. Doğrudan "sayfadaki ilk form" demek,
    hızlı görüntüleme modalı açıkken yanlış ürünün tutarını yazdırırdı.
  */
  function varyantId(el) {
    var n = el;
    while (n && n !== document.body) {
      var inp = n.querySelector ? n.querySelector('form[action*="/cart/add"] [name="id"]') : null;
      if (inp && inp.value) return inp.value;
      n = n.parentElement;
    }

    var genel = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (genel && genel.value) return genel.value;

    return new URLSearchParams(window.location.search).get('variant');
  }

  function uygula() {
    planlandi = false;

    var hedefler = document.querySelectorAll('[data-ap-taksit-tutar]');
    for (var i = 0; i < hedefler.length; i++) {
      var el = hedefler[i];
      var vid = varyantId(el);
      var tutar = vid ? harita[vid] : null;
      if (!tutar) continue;
      if (el.textContent !== tutar) el.textContent = tutar;
    }
  }

  function planla() {
    if (planlandi) return;
    planlandi = true;
    window.requestAnimationFrame(uygula);
  }

  /* Tema fiyatı yeniden yazdığında beden de değişmiş demektir. */
  function izle() {
    var fiyatlar = document.querySelectorAll('[data-price]');
    for (var i = 0; i < fiyatlar.length; i++) {
      if (izleniyor.has(fiyatlar[i])) continue;
      izleniyor.add(fiyatlar[i]);
      new MutationObserver(planla).observe(fiyatlar[i], {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function baslat() {
    haritayiYukle();
    if (!Object.keys(harita).length) return;   /* taksit rozeti sayfada yok */
    izle();
    uygula();

    /* Hızlı görüntüleme gibi sonradan gelen içerikler. */
    new MutationObserver(function () {
      haritayiYukle();
      izle();
      planla();
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', planla, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
